export interface TabProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  id: string;
  badgeText?: string;
  children: React.ReactNode;
}

const Tab = ({ children }: TabProps) => {
  return children;
};

export default Tab;
